import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Switch, Route } from 'react-router';
import './App.css';
import Header from './Header';
import Footer from './Footer';
import SearchView from './SearchView';
// import TestView from './TestView';
import DetailView from './DetailView';
import CookieNotice from './CookieNotice';
import Notfound from './Notfound';

class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <BrowserRouter>
          <div>
            <CookieNotice />
            <Header />
            <Switch>
              {/* <Route path={'/test'} component={TestView}/> */}
              <Route path={'/jobs'} exact={true} component={SearchView}/>
              <Route path={'/jobs/stellenangebot/:alias'} component={DetailView}/>
              <Route path="*" component={Notfound}/>
            </Switch>
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx